const initState = [];
/*
const initState = [
  {
    "nodeId": "0",
    "title": "First input",
    "type": NODE_TYPES.SOURCE,
    "output": [
      "3"
    ],
    "deviceId": "a4d0f43fd705b37335fa047ca5d0068f7c444cdf20e2ec474aa7b21b8408e502",
    coords: { x: 10, y: 10 }
  },
  {
    "nodeId": "1",
    "title": "First output",
    "type": NODE_TYPES.DESTINATION,
    "output": [],
    "deviceId": "905e4745c43eedee796cab78bf6af3f44a76221597987e44e9c39047d8041c36",
    coords: { x: 10, y: 10 }
  },
  {
    "nodeId": "2",
    "title": "Second output",
    "type": NODE_TYPES.DESTINATION,
    "output": [],
    "deviceId": "2409773f188cda81b5306105d1817722f9089681a3b2c1b979f843398d3a15eb",
    coords: { x: 10, y: 10 }
  },
  {
    "nodeId": "3",
    "title": "Gain",
    "type": NODE_TYPES.AUDIONODE,
    "output": [
    ],
    "nodeTypeId": "gain", // plugin type
    "props": {
      "gain": 1
    },
    coords: { x: 10, y: 10 }
  }
];
*/

export default initState;